import React from "react";
import { withRouter } from "react-router-dom";

function AwaitingPayment(props) {
  const { requestData } = props;
  console.log(props, "Awaiting payment");

  const { company_profile, request } = requestData;

  const { id, final_amount, final_comment, discount } = request;
  return (
    <>
      <div className="request-detail-price-wrapper pt-3">
        <div className="row">
          <div className="col-12 col-sm-6 col-md-5 col-lg-4">
            <span className="small-font-size dark-grey-color overline">
              Company Name:
            </span>
            <span className="font-weight-bold pl-3">
              {company_profile && company_profile.name}{" "}
            </span>
          </div>
          <div className="col-12 col-sm-6 col-md-5 col-lg-4">
            <span className="small-font-size dark-grey-color overline">
              Final price:
            </span>
            <span className="font-weight-bold pl-3">${final_amount}</span>
          </div>
          {parseInt(discount) > 0 && (
            <>
              {/*  */}
              {/* <div className="col-12 col-sm-6 col-md-5 col-lg-4 ">
              <span className="small-font-size dark-grey-color overline">
                Discount:
              </span>
              <span className="font-weight-bold pl-3">{discount}%</span>
            </div> */}
              {/*  */}
              <div className="col-12 col-sm-6 col-md-5 col-lg-4 pt-2 pb-1">
                <span className="small-font-size dark-grey-color overline">
                  Discounted price:
                </span>
                <span className="font-weight-bold pl-3">
                  ${final_amount * (1 - parseInt(discount) / 100)}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
      {final_comment && (
        <div className="request-comment-wrapper pt-3">
          <span className="small-font-size dark-grey-color overline mb-2">
            Comment:
          </span>{" "}
          <span className="small-font-size black-color">{final_comment}</span>
        </div>
      )}
      <div className="bid-status-wrapper pt-3">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-6 col-md-5 col-lg-4 text-center">
            <button
              className="custom-buton custom-buton-large w-100"
              data-toggle="modal"
              data-target="#pay-for-request"
              onClick={() => {
                props.history.push("/dashboard/my-requests/make-payment/" + id);
              }}
            >
              Pay
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(AwaitingPayment);
